var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { ProspectSelector } from "@components/common/form/prospect-selector";
const ShareLinkProspect = (_a) => {
    var { form, communityId } = _a, props = __rest(_a, ["form", "communityId"]);
    return (React.createElement(ProspectSelector, Object.assign({ disabled: !form.values.isTracked }, props, { communityId: communityId, required: form.values.isTracked, form: form })));
};
export default ShareLinkProspect;
